import { useState, useEffect, useCallback } from 'react';
import { fetchMyWallet, type MyWalletInfo } from '../services/api/wallet';

export const WALLET_REFRESH_EVENT = 'wallet:refresh';

export function refreshWallet() {
  window.dispatchEvent(new CustomEvent(WALLET_REFRESH_EVENT));
}

export function useWallet(enabled = true) {
  const [wallet, setWallet] = useState<MyWalletInfo | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    if (!enabled) return;
    setLoading(true);
    fetchMyWallet()
      .then(setWallet)
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, [enabled]);

  useEffect(() => { load(); }, [load]);

  useEffect(() => {
    if (!enabled) return;
    window.addEventListener(WALLET_REFRESH_EVENT, load);
    return () => window.removeEventListener(WALLET_REFRESH_EVENT, load);
  }, [enabled, load]);

  return { wallet, loading, error, reload: load };
}
